import { Nilable } from "@shared/utils";

export interface IPaginadoDTO<T> {
    results: T[];
    page: number;
    last_page: number;
    count: number;
}

export class PaginadoDTO<T> {
    public resultados: T[] = [];
    public pagina = 0;
    public ultimaPagina = 0;
    public cantidad = 0;

    constructor(json: Nilable<IPaginadoDTO<T>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: IPaginadoDTO<T>) {
        this.resultados = json.results;
        this.pagina = json.page;
        this.ultimaPagina = json.last_page;
        this.cantidad = json.count;
    }

    public toJSON(): IPaginadoDTO<T> {
        return {
            results: this.resultados,
            page: this.pagina,
            last_page: this.ultimaPagina,
            count: this.cantidad
        };
    }
}
